import React from "react";
import { Link } from "react-router-dom";
import { Film, MoreVertical } from "lucide-react";

const CastingActiveRolesList = ({ dashboardData, navigate }) => {
  return (
    <div className="cdd-card cdd-roles-card">
      <div className="cdd-card-header">
        <h2>My Active Roles</h2>
        <Link to="/dashboard/roles" className="cdd-link-btn">View All</Link>
      </div>
      <div className="cdd-roles-list">
        {dashboardData?.activeRoles?.map((role) => (
          <div className="cdd-role-item" key={role.id}>
            <div className="cdd-role-info">
              <div className="cdd-role-icon-small"><Film size={16} /></div>
              <div>
                <h4 className="cdd-role-title">{role.title}</h4>
                <p className="cdd-role-project">{role.project}</p>
              </div>
            </div>
            <div className="cdd-role-stats">
              <div className="cdd-applicant-count">
                <strong>{role.applicants}</strong>
                <span>Applicants</span>
              </div>
              <button 
                className="cdd-icon-btn" 
                title="Edit Role"
                onClick={() => navigate(`/dashboard/post-roles/${role.id}`)}
              >
                <MoreVertical size={16} />
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CastingActiveRolesList;
